// extracted by mini-css-extract-plugin
export var container = "_tn-0";
export var table = "_tn-2";
export var tableWrapper = "_tn-1";